export default "__VITE_ASSET__CzpFUod1__"